import { FC, useRef } from "react";

import { MUIIcon } from "../../../../../widgets";
import React from "react";
import Webcam from "react-webcam";

interface Step1Props {
    setImage: (image: string) => void
    moveNext?: () => void
    moveBack?: () => void
}

export const Step1: FC<Step1Props> = ({ setImage, moveNext }) => {
    const webcamRef = useRef<Webcam>(null);

    const getScreenshot = React.useCallback(() => {
        if (!webcamRef.current)
            return;

        const imageSrc = webcamRef.current.getScreenshot();
        setImage(imageSrc!);
        // eslint-disable-next-line
    }, [webcamRef])

    return (
        <div className='card bg-light border'>
            <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                className='w-300px card-img-top' />
            <div className='card-footer d-flex py-3'>
                <div className='flex-fill' />
                <button
                    className='btn btn-sm btn-link link-primary'
                    onClick={() => { getScreenshot(); moveNext && moveNext(); }}>
                    Next <MUIIcon iconName='ArrowForwardOutlined' />
                </button>
            </div>
        </div>
    )
}
